import { useOutletContext } from 'react-router-dom'

import AddSupervisorModalV1 from 'modules/surveys/components/Configuration/AddSupervisorModalV1'
import AddEditorModal from 'modules/surveys/components/Settings/Editors/AddEditorModal'
import { useSurveyShowContext } from 'modules/surveys/pages/Show/hooks'
import type SurveyForm from 'modules/surveys/store/models/Form'

export default function AddSupervisorPage() {
  const { form } = useOutletContext<{ form: SurveyForm }>()
  const { survey, hasSurveyV2 } = useSurveyShowContext()

  return hasSurveyV2 && survey ? (
    <AddEditorModal survey={survey} />
  ) : (
    <AddSupervisorModalV1 form={form} />
  )
}
